import React from 'react';
import ReactDOM from 'react-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './bootstrap-important.css';
import './firstScreen.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import("./bootstrap.css").then(math => {
    // console.log(math.add(16, 26));
  });

//   const rootElement = document.getElementById("root");

// if (rootElement.hasChildNodes()) {
//   ReactDOM.hydrate(<App />, rootElement);
// } else {
//   ReactDOM.render(<App />, rootElement);
// }
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// import React from 'react';
// //import ReactDOM from 'react-dom';
// import { hydrate, render } from "react-dom";
// // import 'bootstrap/dist/css/bootstrap.min.css';
// import './bootstrap-important.css';
// import './firstScreen.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';
// // import("./bootstrap.css").then(math => {
// //     // console.log(math.add(16, 26));
// //   });

// import './bootstrap.css';

// //ReactDOM.render(<App />, document.getElementById('root'));
 
// const rootElement = document.getElementById("root");

// if (rootElement.hasChildNodes()) {
//   hydrate(<App />, rootElement);
// } else {
//   render(<App />, rootElement);
// }

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
